module.exports = __webpack_public_path__ + "img/selected-trend-up.a8bbc745.svg";